import styled from 'styled-components';

import Picture from 'components/picture';

const BackgroundPicture = styled(Picture)`
  z-index: 0;
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  width: 100%;
  height: 100%;
`;

export default BackgroundPicture;
